import { BusinessPriceObj } from "../../../../../components/data";

export const recurringBillingData = [
  {
    name: "Standard",
    id: "tier-standard",
    href: "#",
    priceMonthly: BusinessPriceObj.standard,
    description: "Essential tools for your AI needs.",
    features: ["API Integration", "AI Risk Checker", "AI Interview Trainer"],
    featured: false,
  },
  {
    name: "Premium",
    id: "tier-premium",
    href: "#",
    priceMonthly: BusinessPriceObj.premium,
    description: "Advanced AI features with collaboration tools.",
    features: [
      "API Integration",
      "AI Risk Checker",
      "AI Interview Trainer",
      "Case Evaluation",
      "Client Collaboration",
      "Customized Dashboard",
    ],
    featured: true, // Highlight the premium plan
  },
  //   {
  //     name: "Enterprise",
  //     id: "tier-enterprise",
  //     href: "#",
  //     priceMonthly: "$99",
  //     description: "Tailored solutions for your business needs.",
  //     features: ["Get tailored solutions for your business needs"],
  //     featured: false,
  //   },
];

export enum BillingType {
  perApplication = "payPerApplication",
  standard = "standard",
  premium = "premium",
  enterprise = "enterprise",
  staff = "staff",
  starter = "starter",
  growth = "growth",
  starterYearly = "starterYearly",
  growthYearly = "growthYearly",
  essential = "essential",
  essentialYearly = "essentialYearly",
}

export const PlanRank: Partial<Record<BillingType, number>> = {
  [BillingType.starter]: 1,
  [BillingType.starterYearly]: 1,
  [BillingType.essential]: 2,
  [BillingType.essentialYearly]: 2,
  [BillingType.growth]: 3,
  [BillingType.growthYearly]: 3,
};

export interface BillingDataProps {
  id: BillingType;
  title: string;
  price: number;
  pricePeriod?: string;
  features: (string | JSX.Element)[];
  isCustom?: boolean;
  buttonText: string;
}

export const billingData = (
  onceHadASubscriptionPlan: boolean,
  seatPrice: string
): BillingDataProps[] => {
  const temp = [
    {
      id: BillingType.standard,
      title: "Standard",
      price: BusinessPriceObj.standard,
      pricePeriod: "month",
      features: [
        "AI Risk Checker",
        "AI Interview Trainer",
        "Client Management",
        "Case Management",
        "Staff Management",
        "Technical Support",
        `1 Staff Seat (can add up to 2 seats for ${seatPrice}/month, per seat)`,
      ],
      buttonText: "Select Standard",
    },
    {
      id: BillingType.premium,
      title: "Premium",
      price: BusinessPriceObj.premium,
      pricePeriod: "month",
      features: [
        <>
          Everything in <strong className=" text-[#0076E9]">Standard</strong>{" "}
          Plan
        </>,
        "Early access to new features",
        "Case Tracking",
        `3 staff seats (up to 2 additional seats available for ${seatPrice}/month, per seat)`,
      ],
      buttonText: "Select Premium",
    },
    {
      id: BillingType.enterprise,
      title: "Enterprise",
      price: 0,
      pricePeriod: "",
      features: [
        <>
          Everything in <strong className=" text-[#0076E9]">Premium</strong>{" "}
          Plan
        </>,
        "API integrations",
        "Get tailored solutions for your business needs",
      ],
      buttonText: "Contact Us",
      isCustom: true,
    },
  ];

  if (!onceHadASubscriptionPlan) {
    temp.unshift({
      id: BillingType.perApplication,
      title: "Per Application",
      price: BusinessPriceObj.perApplication,
      pricePeriod: "application",
      features: [
        "AI Risk Checker",
        "AI Interview Trainer",
        "Client Management",
        "Case Management",
        "Technical Support",
        "1 Staff Seat",
      ],
      buttonText: "Select Per Application",
    });
  }

  return temp;
};

export enum BillingStripeQuery {
  billingType = "billingType",
  paymentType = "paymentType",
  session_id = "session_id",
  subType = "subType",
}

export enum SubTypeValues {
  forms = "forms",
  fibi = "fibi",
}

export const fibiBillingData = () => {
  const temp = [
    {
      id: [BillingType.starter, BillingType.starterYearly],
      title: "Business Starter Pack",
      subText: "For agencies assisting up to 5 clients",
      // monthPrice: 37_500,
      // yearPrice: 31_250,
      // yearPrice: 750000,
      // savedYearPrice: 150000,
      dollarMonthPrice: 25,
      dollarYearPrice: 250,
      dollarSavedYearPrice: 50,
      features: [
        "5 Interview Simulations",
        "Real-Time Feedback & Personalized Recommendations",
        "Access to Curated Question Library",
        "Transcription in Document For 3 Simulations",
        "Practice History Storage For 3 Months",
      ],
      buttonText: "Select Starter Pack",
      monthPaystackPlan:
        process.env.REACT_APP_PAYSTACK_BUSINESS_STARTER_MONTHLY,
      yearPaystackPlan: process.env.REACT_APP_PAYSTACK_BUSINESS_STARTER_YEARLY,
    },
    {
      id: [BillingType.essential, BillingType.essentialYearly],
      title: "Business Essential Pack",
      subText: "For agencies assisting up to 10 clients",
      // monthPrice: 105_000,
      // yearPrice: 87_500,
      // yearPrice: 1850000,
      // savedYearPrice: 370000,
      dollarMonthPrice: 70,
      dollarYearPrice: 700,
      dollarSavedYearPrice: 140,
      features: [
        "7 Interview Simulations",
        "Real-Time Feedback & Personalized Recommendations",
        "Access to Curated Question Library",
        "Transcription in Document For All Simulations",
        "Practice History Storage For 6 Months",
      ],
      buttonText: "Select Essential Pack",
      monthPaystackPlan:
        process.env.REACT_APP_PAYSTACK_BUSINESS_ESSENTIAL_MONTHLY,
      yearPaystackPlan:
        process.env.REACT_APP_PAYSTACK_BUSINESS_ESSENTIAL_YEARLY,
    },
    {
      id: [BillingType.growth, BillingType.growthYearly],
      title: "Business Growth Pack",
      subText: "For mid-sized agencies assisting up to 18 clients",
      // monthPrice: 270_000,
      // yearPrice: 225_000,
      // yearPrice: 2200000,
      // savedYearPrice: 440000,
      dollarMonthPrice: 180,
      dollarYearPrice: 1800,
      dollarSavedYearPrice: 360,
      features: [
        "10 Interview Simulations",
        "Real-Time Feedback & Personalized Recommendations",
        "Access to Curated Question Library",
        `Transcription in Document For All Simulations`,
        "Practice History Storage For 6 Months",
      ],
      buttonText: "Select Growth Pack",
      monthPaystackPlan: process.env.REACT_APP_PAYSTACK_BUSINESS_GROWTH_MONTHLY,
      yearPaystackPlan: process.env.REACT_APP_PAYSTACK_BUSINESS_GROWTH_YEARLY,
    },
  ];

  return temp;
};
